import BigNumber from "bignumber.js";
import { LeaderboardEntryType } from "context/state";

const computeValues = (
  userNftTokens: LeaderboardEntryType["userNftTokens"],
  collection: string,
) => {
  const nftData = userNftTokens
    .filter(
      (data) =>
        data.collection === collection ||
        data.decodedAttributes?.lpTokenID === collection ||
        data.decodedAttributes?.farmTokenID === collection,
    )
    .map(({ valueUSD, balance, decodedAttributes }) => {
      const split = Boolean(
        decodedAttributes?.lockedRewards ||
          decodedAttributes?.farmTokenAttributes?.lockedRewards,
      );

      return {
        valueUSD,
        balance: split
          ? new BigNumber(balance).dividedBy(2).toFixed(2)
          : balance,
      };
    });

  const valueUSD = nftData
    .map((t) => t.valueUSD)
    .reduce((a, b) => new BigNumber(a).plus(b), new BigNumber(0))
    .toFixed(2);

  const balance = nftData
    .map((t) => t.balance)
    .reduce((a, b) => new BigNumber(a).plus(b), new BigNumber(0))
    .toString(10);

  return { valueUSD, balance };
};

export default computeValues;
